// extracted by mini-css-extract-plugin
export var lessButton = "DownloadSection-module--lessButton--mOJRA";
export var moreButton = "DownloadSection-module--moreButton--YYHSV";
export var title = "DownloadSection-module--title--5KNI+";